import { toast } from 'react-toastify'
import API from '../api'
import { format } from '../formatResponses/plan'
import { usePlans } from '../../store/subscription/usePlans'
import { formatBody } from '../formatBody/plan'

export class Plans {
  setPlans = usePlans.getState().actions.setPlans

  setPlanFactor = usePlans.getState().actions.setPlanFactor

  fixPlansFactor = usePlans.getState().actions.fixPlansFactor

  undoPlansFactor = usePlans.getState().actions.undoPlansFactor

  clearPlans = usePlans.getState().actions.clear

  async findPlans(force = false) {
    try {
      const { data } = await API.get('/subscriptions/commissions/rules')

      const formatedPlans = format.plans(data.storePlans, data.config)

      if (force) {
        this.clearPlans()
      }

      this.setPlans(formatedPlans)
      return formatedPlans
    } catch (error) {
      toast.error(error?.response?.data?.friendly_message, { theme: 'colored' })
      return false
    }
  }

  setFactor = (planId, factor) => {
    if (!planId) {
      toast.error('Informe um plano', {
        theme: 'colored',
      })
      return false
    }

    this.setPlanFactor(planId, factor)
  }

  setSizeValue = (planId, sizeId, value) => {
    if (!planId || !sizeId || !value) {
      toast.error('Informe todos os parâmetros necessários', {
        theme: 'colored',
      })
      return false
    }

    usePlans.getState().actions.setSizeValue(planId, sizeId, value)
  }

  async saveRules() {
    try {
      const allPlans = usePlans.getState().data.plans
      if (!allPlans) {
        toast.error(
          'Nenhum plano encontrado, atualize a página e tente novamente!',
          { theme: 'colored' },
        )
        return false
      }

      // Filtrar apenas planos com alterações
      const changedFactorPlans = allPlans.filter((plan) => plan.factor !== plan.oldFactor)
      const plansWithSizeChanges = allPlans
        .map((plan) => ({
          plan,
          changedSizes: (plan.sizes || []).filter((s) => s.value !== s.oldValue),
        }))
        .filter((p) => p.changedSizes.length > 0)

      // Se não há alterações de preços, ainda assim enviar as regras
      if (plansWithSizeChanges.length === 0) {
        // Apenas avisar que não há alterações de preços, mas ainda enviar as regras
        console.log('Nenhuma alteração de preços detectada, enviando apenas regras de planos.')
      }

      // Preparar dados
      const subscriptionRules = this.formatAllRules(allPlans) // Todos os planos
      const updatePriceSub = this.formatChangedPriceSub(plansWithSizeChanges) // Apenas alterações
      
      const { data } = await API.post('/subscriptions/commissions/rules', {
        subscriptionRules,
        updatePriceSub,
      })

      if (!data) {
        toast.error('Erro ao salvar regras', { theme: 'colored' })
        return false
      }

      this.fixPlansFactor()

      toast.success(data?.message, { theme: 'colored' })
      return data
    } catch (error) {
      toast.error(error?.response?.data?.friendly_message, { theme: 'colored' })
      return false
    }
  }

  // Formatar todas as regras (todos os planos)
  formatAllRules(allPlans) {
    return allPlans.map(plan => ({
      planType: plan.name,
      factor: plan.factor || 1
    }))
  }

  // Formatar apenas preços com alterações
  formatChangedPriceSub(plansWithSizeChanges) {
    const priceUpdates = []
    
    plansWithSizeChanges.forEach(({ plan, changedSizes }) => {
      // Enviar apenas os sizes que realmente mudaram
      changedSizes.forEach(size => {
        priceUpdates.push({
          petSize: size.name,
          planType: plan.name,
          oldValue: size.oldValue,
          newValue: size.value,
          cluster: size.upgradePrice.find((cluster) => cluster.price == size.value)
        })
      })
    })

    return priceUpdates
  }

  undoRules() {
    this.undoPlansFactor()
  }
}
